<i18n>
{
	"en": {
		"failedToRemoveOrderTrip": "Failed to remove order from trip",
		"failedToRemoveOrderTransporter": "Failed to remove order from transporter",
		"orderRemovedFromTrip": "Order removed from trip",
		"orderRemovedFromTransporter": "Order removed from transporter",
		"failedToAddOrderToTrip": "Failed to add order to trip {number}",
		"orderAddedToTrip": "Order added to trip {number}"
	},
	"no": {
		"failedToRemoveOrderTrip": "Kunne ikke fjerne ordren fra turen",
		"failedToRemoveOrderTransporter": "Kunne ikke fjerne oppdrag fra transportøren",
		"orderRemovedFromTrip": "Oppdrag fjernet fra turen",
		"orderRemovedFromTransporter": "Oppdrag fjernet fra transportøren",
		"failedToAddOrderToTrip": "Kunne ikke legge til oppdrag på turen {number}",
		"orderAddedToTrip": "Oppdrag lagt til tur {number}"
	}
}
</i18n>
<template>
	<t-horizontal-panel style="overflow: hidden;">
		<trip-search-filters slot="left" />
		<trip-list style="flex:1;" />
		<ConfirmRemoveTripOrder
			:isShown="confirmRemoveTripOrderVisible"
			:trip="tripDetails"
			@close="toggleRemoveTripOrder(false)"
			@confirm="confirmRemoveOrdersFromTrip"
		/>
		<ConfirmRemoveTransporterOrder
			:isShown="confirmRemoveTransporterOrderVisible"
			@close="toggleRemoveTransporterOrder(false)"
			@confirm="confirmRemoveOrdersFromTransporter"
		/>
		<!-- <MoveOrderToDifferentTripSelect
			:isShown="moveLoadedOrderVisible"
			:currentTrip="selectedTrip"
			:order="selectedOrder"
			:disableSubmit="moveLoadedOrderProcessing"
			@close="moveLoadedOrderVisible = false"
			@moveOrder="onMoveOrderToDifferentTransporter"
		/> -->
	</t-horizontal-panel>
</template>

<script>
import { mapDynamicState, mapDynamicActions } from '@/core/mapDynamic';
import { tryRegisterStoreDynamically } from './store/tripSearch.store.js';
import moment from 'moment';

import TripSearchFilters from './TripSearchFilters';
import TripList from './TripList';
import ConfirmRemoveTripOrder from './modals/ConfirmRemoveTripOrder';
import ConfirmRemoveTransporterOrder from './modals/ConfirmRemoveTransporterOrder';
// import MoveOrderToDifferentTripSelect from './modals/MoveOrderToDifferentTripSelect';

export default {
	name: 'TripSearch',
	components: {
		TripSearchFilters,
		TripList,
		ConfirmRemoveTripOrder,
		ConfirmRemoveTransporterOrder,
		// MoveOrderToDifferentTripSelect
	},
	data() {
		return {
			confirmRemoveTripOrderVisible: false,
			confirmRemoveTransporterOrderVisible: false,
			ordersToRemove: [],
			moveLoadedOrderVisible: false,
			moveLoadedOrderProcessing: false,
			selectedTrip: {},
			selectedOrder: {}
		};
	},
	computed: {
		...mapDynamicState('computedStoreNamespace', ['tripDetails']),
		searchId() {
			return this.$route.params.searchId || -1;
		},
		computedStoreNamespace() {
			return `tripSearch/${this.searchId}`;
		}
	},

	methods: {
		...mapDynamicActions('computedStoreNamespace', [
			'removeOrdersFromTrip',
			'removeOrdersFromTransporter',
			'moveOrderToDifferentTrip'
		]),
		toggleRemoveTransporterOrder(value) {
			this.confirmRemoveTransporterOrderVisible = value;
		},
		toggleRemoveTripOrder(value) {
			this.confirmRemoveTripOrderVisible = value;
		},
		onRemoveOrders(orders) {
			if (!orders) return;
			this.ordersToRemove = orders;
			if (this.tripDetails.type.internalCode === 'external') {
				let timeCheck = moment.utc().subtract(5,'minutes')
					.valueOf();
				let hasSentOrders = this.ordersToRemove.some(x => x.createdAt < timeCheck || x.sentStatus);
				if (hasSentOrders)
					this.toggleRemoveTransporterOrder(true);
				else
					this.confirmRemoveOrdersFromTransporter();
			} else {
				this.toggleRemoveTripOrder(true);
			}
		},
		confirmRemoveOrdersFromTrip() {
			try {
				this.removeOrdersFromTrip(this.ordersToRemove);
				this.$notify({
					type: 'success',
					title: `${this.$t('orderRemovedFromTrip')}`
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToRemoveOrderTrip')
				});
			}
		},
		confirmRemoveOrdersFromTransporter() {
			try {
				this.removeOrdersFromTransporter(this.ordersToRemove);
				this.$notify({
					type: 'success',
					title: `${this.$t('orderRemovedFromTransporter')}`
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToRemoveOrderTransporter')
				});
			}
		},
		showMoveLoadedOrder({ order, trip }) {
			this.selectedOrder = order;
			this.selectedTrip = trip;
			this.moveLoadedOrderVisible = true;
		},
		async onMoveOrderToDifferentTransporter(data) {
			this.moveLoadedOrderProcessing = true;
			try {
				await this.moveOrderToDifferentTrip(data);
				this.$notify({
					type: 'success',
					title: `${this.$t('orderAddedToTrip', { number: this.selectedTrip.tripNumber })}`
				});
				this.moveLoadedOrderVisible = false;
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t(e.message || 'failedToAddOrderToTrip', { number: this.selectedTrip.tripNumber }),
					duration: -1
				});
			}
			this.moveLoadedOrderProcessing = false;
		}
	},
	beforeRouteEnter(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	},
	beforeRouteUpdate(to, from, next) {
		let id = to.params.searchId || -1;
		tryRegisterStoreDynamically(id);
		next();
	}
};
</script>

<style lang="scss" scoped>

</style>
